import CRUDService from "./base/CRUDService";

class TransactionItemService extends CRUDService {

  getBaseURL() {
    return "/ton/v1/transaction-items"
  }

  deleteAllTransactionItems (transactionId, productTypeId) {
    return super.getHttpRequest().delete(`${this.getBaseURL()}/transactions/${transactionId}/productTypes/${productTypeId}`)
  }

  getAllItemsWithWrongWorkflow (transactionId) {
    return this.httpRequest.get(`${this.getBaseURL()}/transactions/${transactionId}/has-problem`)
  }
}

export default TransactionItemService



// WEBPACK FOOTER //
// ./src/services/TransactionItemsService.js